export default function utf8ToBase64(input: string): string {
	const bytes = new TextEncoder().encode(input)
	let binary = ""
	bytes.forEach((byte) => {
		binary += String.fromCharCode(byte)
	})
	return btoa(binary)
}
